import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, labelModes, services, states } from '@/utils'

import button from '@/components/button'
import generatorRow from '@/components/generator/row'
import info from '@/components/info'
import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'
import preloader from '@/components/preloader'
import routesFormLink from '@/components/services/routes/form/link'

const serviceNameViaPoint = services['otp-settings/widgets'].split('/').join('.')

function renderHeader(h) {
  return h(
    components['tabs-header'],
    {
      props: {
        value: this.tab,
        tabs: this.tabs
      },
      on: {
        input: event => {
          this.tab = event
        }
      }
    }
  )
}

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.infos.channels`)
      }
    }
  )
}
function renderWarning(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.warnings.channels`),
        color: Colors.warning
      }
    }
  )
}

function renderLinkToChannel(h, item) {
  if (this.checkPermissions(`advanced.${services['otp-settings/channels'].split('/').join('.')}.create`)) {
    return h(
      routesFormLink,
      {
        props: {
          value: { id: item.otpChannelSettingsId },
          service: services['otp-settings/channels'].split('/').join('.')
        }
      }
    )
  }
}
function renderChannelField(h, item) {
  return h(
    components.select,
    {
      props: {
        value: item.otpChannelSettingsId,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.channels`),
        service: services['otp-settings/channels'],
        picks: [ 'id', 'name', 'channelType' ],
        itemTitle: 'name',
        itemsDisabled: this.proxy.otpWidgetChannelSettings.map(({ otpChannelSettingsId }) => {
          return otpChannelSettingsId
        }),
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true
      },
      on: {
        input: event => {
          item.otpChannelSettingsId = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.channelType,
                title: item.name
              }
            }
          )
        },
        item: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.channelType,
                title: item.name,
                as: 'text'
              }
            }
          )
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [
      h(
        button,
        {
          props: {
            icon: 'save',
            label: this.getTranslate('misc.buttons.save'),
            color: Colors.primary,
            mode: buttonModes.flat,
            loading: this.loading,
            disabled: this.loading
          },
          on: {
            click: () => {
              this.attachChannels()
            }
          }
        }
      )
    ]
  )
}
function renderGeneratorRow(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy.otpWidgetChannelSettings,
        defaultValue: {
          otpChannelSettingsId: undefined,
          priority: 0
        },
        sortable: true
      },
      scopedSlots: {
        row: ({ item }) => {
          let gridTemplateColumns = '1fr'
          if (this.checkPermissions(`advanced.${services['otp-settings/channels'].split('/').join('.')}.create`)) {
            gridTemplateColumns = '1fr auto'
          }

          return h(
            'div',
            {
              class: 'grid grid-gap--8',
              style: { 'grid-template-columns': gridTemplateColumns }
            },
            [
              renderChannelField.call(this, h, item),
              renderLinkToChannel.call(this, h, item)
            ]
          )
        },
        footer: () => {
          return renderFooter.call(this, h)
        }
      },
      on: {
        input: event => {
          this.proxy.otpWidgetChannelSettings = event
        }
      }
    }
  )
}
function renderBody(h) {
  if (this.restData[services['otp-settings/channels']].find.state === states.loading) {
    return h(preloader)
  }

  if (this.restData[services['otp-settings/channels']].find.state === states.ready) {
    if (this.restData[services['otp-settings/channels']].find.pagination.total === 0) {
      return renderWarning.call(this, h)
    }
  }

  return [
    renderInfo.call(this, h),
    renderGeneratorRow.call(this, h)
  ]
}

function renderTab(h) {
  return h(
    components.card,
    {
      class: 'grid grid-gap--8 pa-2',
      props: {
        rounded: true,
        outline: true
      },
      key: 'channels'
    },
    [ renderBody.call(this, h) ]
  )
}

function renderContent(h) {
  return h(
    components.tabs,
    {
      props: { value: this.tab },
      scopedSlots: {
        body: () => {
          return this.tabs.map(tab => {
            return renderTab.call(this, h, tab.key)
          })
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderHeader.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
